import styled from "styled-components";

export const BackButtonContainer = styled.div`
  padding: 2px;
`;
